import {
    cleanCommonParams,
    mapVideoRequestBrandsParams,
} from './common';

const mapCoBrandedVideoRequestParams = (
    isCreate,
    {
        co_branded_video_request_brands,
        generating,
        videos_requested,
        state,
        brands,
        co_branded_video_request_notifications,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            co_branded_video_request: {
                ...cleanCommonParams(params),
                ...mapVideoRequestBrandsParams(isCreate, co_branded_video_request_brands),
            },
        });
    });
};

export { mapCoBrandedVideoRequestParams };
